<template>
  <div>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-3">
      <v-layout wrap>
        <v-flex
          xs12
          v-if="request && request.id"
          style="display: flex; justify-content: space-between; align-items: center;"
          class="py-1"
        >
          <div>
            <router-link
              :to="{ name: 'HelpDeskTechnicianRequests' }"
              class="font-weight-bold text--primary"
              style="text-decoration: none;"
            >
              <span style="color:green"> All Support Requests</span>
            </router-link>

            <span>/{{ request.subject }}</span>
          </div>

          <div>
            <v-btn
              small
              class="mt-0"
              style="color: green; min-width: 36px;"
              :disabled="!hasPrevTicket"
              @click="goToPrevTicket"
              title="Previous"
            >
              &lt;
            </v-btn>
            <v-btn
              small
              class="mt-0"
              style="color: green; min-width: 36px;"
              :disabled="!hasNextTicket"
              @click="goToNextTicket"
              title="Next"
            >
              &gt;
            </v-btn>
          </div>
        </v-flex>

        <v-flex xs12 class="pb-2 pt-0">
          <v-tabs
            v-if="request && request.id"
            v-model="activeTab"
            class="ticket-tabs mb-4"
          >
            <v-tab :class="activeTab === 0 ? 'tab-active' : ''">
              View Ticket
            </v-tab>
            <v-tab :class="activeTab === 1 ? 'tab-active' : ''">
              Edit Ticket
            </v-tab>
            <v-tab :class="activeTab === 2 ? 'tab-active' : ''">
              View User
            </v-tab>
            <v-tab :class="activeTab === 3 ? 'tab-active' : ''">
              Resolution
            </v-tab>
            <v-tab :class="activeTab === 4 ? 'tab-active' : ''">
              Logs
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <v-card
                style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
              >
                <div v-if="loading" class="px-3 mt-2 py-2">
                  <v-progress-linear
                    :indeterminate="true"
                    color="success"
                  ></v-progress-linear>
                </div>
                <v-layout row justify-space-between>
                  <v-layout column class="ma-1 px-3">
                    <v-card-text
                      class="mb-0 pb-0 pt-2 pl-2"
                      v-if="request && request.id"
                    >
                      <div class="ml-0 my-2 body-1 font-weight-light">
                        Requested By:

                        <span class="font-weight-medium">
                          <a @click="searchUserTickets">{{
                            request.requesterName
                          }}</a>
                        </span>

                        On:
                        <span class="font-weight-medium">{{
                          request.createdAt | time
                        }}</span>
                        User:
                        <span class="font-weight-medium">{{ meUsername }}</span>
                        <span v-show="request.requesterEmailID">
                          Email:
                        </span>

                        <span class="font-weight-medium">{{
                          request.requesterEmailID
                        }}</span>
                        Site:
                        <span class="font-weight-medium">{{
                          request.requestSiteName
                        }}</span>
                        Create via:
                        <span class="font-weight-medium"
                          >{{ request.source }}
                          {{
                            request.itReceptionBy
                              ? `: ${request.itReceptionBy}`
                              : ""
                          }}</span
                        >
                      </div>
                      <v-layout row align-center>
                        <v-flex xs9>
                          <div class="mt-0 ml-3 my-2 body-1 font-weight-light">
                            <v-layout row class="mb-2">
                              <div class="font-weight-medium mr-2">
                                Technician:
                              </div>
                              <div>
                                {{ getTechnician() }}
                              </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                              <div class="font-weight-medium mr-2">
                                Category:
                              </div>
                              <div>
                                {{ request.categoryName }}
                              </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                              <div class="font-weight-medium mr-2">
                                Priority:
                              </div>

                              <div>
                                <v-icon
                                  id="PriorityColor"
                                  small
                                  :color="getPriorityColor()"
                                  >mdi-box-shadow</v-icon
                                >
                                {{ getPriority() }}
                              </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                              <div class="font-weight-medium mr-2">
                                ETA:
                              </div>

                              <div>
                                {{ getETA() }}
                              </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                              <div class="font-weight-medium mr-2">
                                Ticket Number:
                              </div>
                              <div v-if="isTechnician()">
                                <a
                                  style="color: green;"
                                  :href="
                                    `https://utaw.sdpondemand.manageengine.com/app/itdesk/ui/requests/${
                                      request.manageengineID
                                    }/details`
                                  "
                                  target="_blank"
                                  >{{ "#" + request.displayID
                                  }}<v-icon small color="green"
                                    >mdi-open-in-new</v-icon
                                  ></a
                                >
                              </div>
                              <div v-if="!isTechnician()">
                                {{ "#" + request.displayID }}
                              </div>
                            </v-layout>
                          </div>
                        </v-flex>
                        <v-flex>
                          <v-layout align-center>
                            <v-icon
                              dark
                              style="font-size: 50px;"
                              :color="getStatusIconColor()"
                              >{{ getStatusIcon() }}</v-icon
                            >
                            <div
                              v-if="!showStatusDropdown"
                              class="title pt-3 status-text"
                              @click="showStatusDropdown = true"
                              style="cursor: pointer;"
                            >
                              {{ request.statusName }}
                              <v-icon small class="ml-1">mdi-pencil</v-icon>
                            </div>
                            <v-select
                              v-else
                              v-model="selectedStatus"
                              :items="['Open', 'Closed', 'On Hold']"
                              item-text="text"
                              item-value="value"
                              dense
                              class="ml-2"
                              style="max-width: 120px;"
                              @change="onStatusChange"
                              @blur="showStatusDropdown = false"
                              autofocus
                            ></v-select>
                          </v-layout>
                          <div
                            class="mt-2 ml-0 pr-0"
                            v-html="getClosedInfo()"
                          ></div>
                        </v-flex>
                      </v-layout>
                      <v-card
                        class="mb-3"
                        style="border: 0px solid rgb(255, 255, 255); padding-top: 40px;"
                      >
                        <div
                          class="card-header"
                          style="background: rgb(202, 203, 232); display: flex ;"
                        >
                          <div
                            class="ml-3 font-weight-bold pt-1 pb-1"
                            style="font-size: 20px;"
                          >
                            {{ request.subject }}
                          </div>
                          <div
                            style="margin-left: auto; margin-right: 20px;"
                          ></div>
                        </div>
                        <v-layout
                          row
                          justify-end
                          class="mb-2 mt-4 mr-2"
                          v-if="
                            request.description ||
                              JSON.parse(this.request.attachments).length > 0
                          "
                        >
                          <v-flex xs11>
                            <v-card
                              style="border: 2px solid rgb(243, 241, 249);  padding-top: 40px;"
                            >
                              <div
                                class="card-header"
                                style="background: rgb(243, 241, 249);"
                              >
                                <div class="ml-3">
                                  {{ request.requesterName }}
                                  -
                                  {{ request.createdTimeDisplayValue }}
                                </div>
                              </div>

                              <div
                                class="ml-3 pl-3 mr-3 pr-3 mt-4 my-3 "
                                v-html="request.description"
                              ></div>
                              <v-divider class="mt-3"></v-divider>
                              <div
                                class="subheading font-weight-light ml-3 mt-3 mb-1"
                              >
                                {{ getAttachmentText() }}
                              </div>
                              <div class="attachments-container">
                                <div
                                  v-for="attachment in getAttachments()"
                                  :key="attachment.name"
                                  class="ml-3"
                                >
                                  <v-btn
                                    v-if="!isAudioFile(attachment.name)"
                                    class="mt-2 ml-1 px-3 button-attachment"
                                    @click="loadFile(attachment)"
                                  >
                                    <v-icon color="blue" left dark
                                      >mdi-file</v-icon
                                    >
                                    {{ truncateText(attachment.name) }}
                                    <v-icon right>mdi-open-in-new</v-icon>
                                  </v-btn>

                                  <audio v-else controls class="mt-2 ml-1">
                                    <source
                                      :src="getAudioSrc(attachment)"
                                      type="audio/mpeg"
                                    />
                                  </audio>
                                </div>
                              </div>
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          v-show="!request.description"
                          class="mt-3 mb-3"
                        ></v-layout>

                        <v-layout
                          row
                          justify-end
                          class="mr-2"
                          v-if="
                            this.loadAllConversationsBtn ||
                              this.showConversationBtn
                          "
                        >
                          <v-flex xs11>
                            <v-card
                              style="border: 3px solid rgb(211, 219, 218); padding-top: 33px;"
                            >
                              <button
                                class="card-header"
                                style="background: rgb(211, 219, 218); text-align: left;"
                                :disabled="loadingConversations"
                                @click="clickConversationBtn()"
                              >
                                <div
                                  v-show="
                                    !loadingConversations && showConversationBtn
                                  "
                                  style="text-align: center;"
                                >
                                  Click here to Show all conversations
                                </div>
                                <div
                                  v-show="loadingConversations"
                                  style="text-align: center;"
                                >
                                  loading conversations...
                                </div>
                                <div
                                  v-show="loadAllConversationsBtn"
                                  style="text-align: center;"
                                >
                                  Click on conversation or click here to expand
                                  all conversations
                                </div>
                              </button>
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          row
                          justify-end
                          class="mr-2"
                          v-for="(conversation, index) in conversationList"
                        >
                          <v-flex xs11>
                            <v-card
                              :style="
                                `border: 3px solid rgb(${
                                  conversation.type === 'CONVERSATION'
                                    ? '255, 229, 229'
                                    : conversation.type === 'NOTES'
                                    ? '250, 228, 163'
                                    : '217, 255, 235'
                                }); bposition: relative; padding-top: 33px;`
                              "
                            >
                              <button
                                class="card-header"
                                :disabled="conversation.load"
                                :style="
                                  `background: rgb(${
                                    conversation.type === 'CONVERSATION'
                                      ? '255, 229, 229'
                                      : conversation.type === 'NOTES'
                                      ? '250, 228, 163'
                                      : '217, 255, 235'
                                  }); text-align: left;`
                                "
                                @click="expandConversation(index)"
                              >
                                <div
                                  class="ml-3"
                                  style="display: flex; align-items: center; width: 100%;"
                                >
                                  <div>
                                    {{
                                      conversation.senderName != "UserPortal"
                                        ? conversation.senderName + " - "
                                        : ""
                                    }}

                                    {{ conversation.timeDisplayValue }}
                                    <span v-if="conversation.hasAttachments">
                                      -
                                      <v-icon>mdi-attachment</v-icon>
                                    </span>
                                  </div>
                                  <span
                                    style="margin-left: auto; margin-right: 50%;"
                                    v-show="
                                      !conversation.expanded &&
                                        !conversation.load
                                    "
                                  >
                                    <v-icon small>mdi-arrow-expand</v-icon>
                                  </span>
                                  <span
                                    style="margin-left: auto; margin-right: 50%;"
                                    v-show="conversation.load"
                                  >
                                    load...
                                  </span>
                                </div>
                              </button>

                              <div
                                v-show="conversation.expanded"
                                class="ml-0 mt-4 pl-3 my-3"
                              >
                                <h6
                                  class="font-weight-bold"
                                  v-html="conversation.subject"
                                ></h6>
                                <p class="mt-2" v-if="conversation.sendTo">
                                  <b>To:</b>
                                  {{ getSendCTo(conversation.sendTo) }}
                                </p>
                                <v-divider class="mt-3 mb-3"></v-divider>
                                <p v-html="conversation.description"></p>
                                <v-divider
                                  v-if="conversation.attachments"
                                  class="mt-3"
                                ></v-divider>
                                <div
                                  v-if="conversation.attachments"
                                  class="subheading font-weight-light ml-3 mt-3 mb-1"
                                >
                                  {{
                                    getConversationAttachmentCount(
                                      conversation.attachments
                                    )
                                  }}
                                </div>
                                <div
                                  class="attachments-container"
                                  v-if="conversation.attachments"
                                >
                                  <div
                                    v-for="attachment in getConversationAttachments(
                                      conversation.attachments
                                    )"
                                    :key="attachment.name"
                                    class="ml-3"
                                  >
                                    <v-btn
                                      v-if="!isAudioFile(attachment.name)"
                                      class="mt-2 ml-1 px-3 button-attachment"
                                      @click="loadFile(attachment)"
                                    >
                                      <v-icon color="blue" left dark
                                        >mdi-file</v-icon
                                      >
                                      {{ truncateText(attachment.name) }}
                                      <v-icon right>mdi-open-in-new</v-icon>
                                    </v-btn>

                                    <audio v-else controls class="mt-2 ml-1">
                                      <source
                                        :src="getAudioSrc(attachment)"
                                        type="audio/mpeg"
                                      />
                                    </audio>
                                  </div>
                                </div>
                              </div>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-spacer></v-spacer>
                      <div v-if="request && request.id">
                        <v-flex
                          style="display: flex; align-items: center; justify-content: center; width: 100%;"
                        >
                          <!-- <v-btn
                  style="color: green;"
                  class="mr-3 mb-2"
                >
                  Edit Ticket
                </v-btn> -->
                          <v-btn
                            style="color: green;"
                            class="mr-3 mb-2"
                            @click="addNoteDialog = true"
                          >
                            Add Note
                          </v-btn>
                          <v-btn
                            style="color: green;"
                            class="mr-3 mb-2"
                            @click="openReplyDialog"
                          >
                            Reply
                          </v-btn>
                        </v-flex>
                      </div>
                    </v-card-text>
                  </v-layout>
                </v-layout>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-flex xs8 class="pa-0">
                <HelpDeskTechnicianRequestEdit
                  v-if="activeEdit"
                  :initialData="request"
                  @updated="updated"
                  @cancel="activeTab = 0"
                />
              </v-flex>
            </v-tab-item>
            <v-tab-item>
              <v-layout row wrap v-if="activeUserView">
                <v-flex
                  xs4
                  v-for="_requester in requester"
                  :key="_requester.id"
                >
                  <ManageengineUserView
                    :initial-data="{ user: _requester, fromTicketTab: true }"
                    @saveChanges="reloadData"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab-item>
              <v-layout row wrap v-if="activeResolution">
                <v-flex xs4>
                  <Resolution
                    :initial-data="{ ticket: request }"
                    @updated="updated"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout row wrap v-if="activeLogs">
                <v-flex xs6>
                  <Logs :initial-data="{ ticket: request.displayID }" />
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-container>
    <close-ticket-dialog
      v-if="request && request.id"
      v-model="closeTicketDialog"
      :initial-data="{ request: request, technician: true }"
      @tickedClosed="loadRequest()"
    />
    <v-dialog v-model="addNoteDialog" persistent max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline">Add Note</span>
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-Textarea
                  v-model="addNoteDescription"
                  label="Write a Note"
                  outline
                  ref="addNote"
                ></v-Textarea>
              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>

            <v-btn
              color="default"
              @click="(addNoteDialog = false), (addNoteDescription = '')"
              dark
              >Cancel</v-btn
            >
            <v-btn :loading="processing" color="success" @click="addNote"
              >Send</v-btn
            >
            <!-- <input type="file" multiple style="display: none" ref="files" @change="onFilePicked($event)" /> -->
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="replyDialog" persistent max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline">Reply</span>
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <div
                  contenteditable="true"
                  ref="reply"
                  class="reply-editor"
                  v-html="replyTemplate"
                  @input="updateReplyDescription"
                ></div>
              </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>

            <v-btn color="default" @click="replyDialog = false" dark
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="technicianReply"
              >Send</v-btn
            >
            <!-- <input type="file" multiple style="display: none" ref="files" @change="onFilePicked($event)" /> -->
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <UserTicketsDialog
      v-if="SearchUserTickets"
      :initial-data="{
        manageengineUser: requester.find(
          (r) => r.id === this.request.requesterID
        ),
      }"
      @closed="SearchUserTickets = false"
    />
  </div>
</template>
<script>
import { formatPhoneNumber, truncate, pluralize } from "../../utils/helpers.js";
import CloseTicketDialog from "./CloseTicketDialog.vue";
import {
  getETA,
  loadFile,
  isTechnician,
  getStatusIcon,
  getStatusIconColor,
  getClosedInfo,
  getPriority,
  getPriorityColor,
  isAudioFile,
  getAudioSrc,
  getTechnician,
} from "./helpDeskHelpers.js";
import UserTicketsDialog from "./UserTicketsDialog.vue";
import HelpDeskTechnicianRequestEdit from "./HelpDeskTechnicianRequestEdit.vue";
import ManageengineUserView from "./ManageengineUserView.vue";
import Resolution from "./Resolution.vue";
import Logs from "./Logs.vue";
export default {
  metaInfo() {
    return {
      title: `Support Ticket #${this.$route.params.id} | Technician`,
    };
  },
  components: {
    CloseTicketDialog,
    UserTicketsDialog,
    HelpDeskTechnicianRequestEdit,
    ManageengineUserView,
    Resolution,
    Logs,
  },
  data: () => ({
    activeTab: 0,
    loading: false,
    request: null,
    requester: null,
    SearchUserTickets: false,
    showConversationBtn: false,
    loadingConversations: false,
    loadAllConversationsBtn: false,
    conversationList: null,
    conversationAttachments: null,
    processing: false,
    reopenProcessing: false,
    loading: true,
    closeTicketDialog: false,
    meUsername: null,
    addNoteDialog: false,
    addNoteDescription: "",
    replyDialog: false,
    replyDescription: "",
    replyTemplate: "",
    regID: "",
    selectedStatus: "",
    showStatusDropdown: false,
    activeEdit: false,
    activeUserView: false,
    activeResolution: false,
    activeLogs: false,
    // pagination: {
    //   totalCount: 0,
    //   rowsPerPage: 5,
    //   page: 1,
    // },
  }),

  computed: {
    ticketIds() {
      const query = this.$route.query || {};
      const numericKeys = Object.keys(query)
        .filter((k) => !isNaN(k))
        .sort((a, b) => Number(a) - Number(b));
      return numericKeys.map((k) => query[k]);
    },
    currentTicketIndex() {
      if (!this.$route.params || !this.$route.params.id) return -1;
      return this.ticketIds.indexOf(this.$route.params.id);
    },
    hasPrevTicket() {
      return this.currentTicketIndex > 0;
    },
    hasNextTicket() {
      return (
        this.currentTicketIndex > -1 &&
        this.currentTicketIndex < this.ticketIds.length - 1
      );
    },
  },

  watch: {
    "$route.params.id": {
      immediate: false,
      async handler() {
        this.loading = true;
        await this.load();
      },
    },
    activeTab: {
      immediate: true,
      handler(val) {
        this.activeEdit = val === 1;
        this.activeUserView = val === 2;
        this.activeResolution = val === 3;
        this.activeLogs = val === 4;
      },
    },
  },

  async created() {
    await this.load();
  },
  methods: {
    async getManageengineUserInfo() {
      try {
        const response = await this.$http.get(
          `api/manageengineUSers/getManageengineUserInfo?id=${
            this.request.requesterID
          }`
        );
        this.requester = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    goToOffset(offset) {
      const ids = this.ticketIds;
      if (!ids || ids.length === 0) return;
      const currentIndex = this.currentTicketIndex;
      if (currentIndex === -1) return;
      const nextIndex = currentIndex + offset;
      if (nextIndex < 0 || nextIndex >= ids.length) return;
      const nextId = ids[nextIndex];
      this.$router.push({
        name: this.$route.name,
        params: { ...this.$route.params, id: nextId },
        query: this.$route.query,
      });
    },
    goToPrevTicket() {
      this.clearConversations();
      this.goToOffset(-1);
      this.activeTab = 0;
    },
    goToNextTicket() {
      this.clearConversations();
      this.goToOffset(1);
      this.activeTab = 0;
    },
    clearConversations() {
      this.showConversationBtn = false;
      this.loadingConversations = false;
      this.loadAllConversationsBtn = false;
      this.conversationList = null;
      this.conversationAttachments = null;
    },
    searchUserTickets() {
      this.SearchUserTickets = true;
    },
    async load() {
      await this.loadRequest();
      this.selectedStatus = this.request.statusName;
      await this.getManageengineUserInfo();
    },
    async loadRequest() {
      try {
        const response = await this.$http.get(
          `api/manageengine/getRequestbyID?id=${this.$route.params.id}`
        );

        if (response.notFound) {
          this.$notify({
            text:
              "Ticket not found – it was probably deleted or merged with another request.",
            group: "notification",
            type: "error",
          });
          setTimeout(() => {
            this.$router.push("/helpdesk/technician/requests");
          }, "500");
          return;
        }
        this.request = response.request;
        this.meUsername = response.username;
        this.loading = false;
        if (
          response.request.notificationStatus != null ||
          response.request.hasNotes == true
        ) {
          this.showConversationBtn = true;
        }
      } catch (e) {
        setTimeout(() => {
          this.$router.push("/helpdesk/technician/requests");
        }, "500");
      }
    },

    isTechnician() {
      return isTechnician();
    },

    formatPhoneNumber(number) {
      return formatPhoneNumber(number);
    },
    getStatusIcon() {
      return getStatusIcon(this.request);
    },

    getStatusIconColor() {
      return getStatusIconColor(this.request);
    },

    getClosedInfo() {
      return getClosedInfo(this.request);
    },

    getAttachmentText() {
      const getAttachments = this.getAttachments();
      if (!getAttachments || getAttachments.length == 0) {
        return;
      }
      return (
        getAttachments.length +
        " " +
        pluralize("Attachment", getAttachments.length)
      );
    },
    getAttachments() {
      if (!this.request || !this.request.attachments) return [];
      return JSON.parse(this.request.attachments);
    },

    getTechnician() {
      return getTechnician(this.request);
    },
    // downloadAttachment(attachment) {
    //     window.location = attachment;
    // },
    truncateText(attachment) {
      return truncate(attachment, 30);
    },
    loadFile(file) {
      loadFile(file);
    },

    isAudioFile(fileName) {
      return isAudioFile(fileName);
    },

    getAudioSrc(file) {
      return getAudioSrc(file);
    },
    getPriority() {
      return getPriority(this.request.priorityName);
    },
    getETA() {
      return getETA(this.request);
    },
    getPriorityColor() {
      return getPriorityColor(this.request.priorityName);
    },

    clickConversationBtn() {
      if (!this.loadAllConversationsBtn) {
        this.getConversations();
      } else {
        this.expandAllConversations();
      }
    },

    async getConversations() {
      this.loadingConversations = true;
      this.loading = true;
      const conversations = await this.$http.get(
        `api/manageengine/GetConversationsByTicket?manageengineID=${
          this.request.manageengineID
        }&requestID=${this.request.id}&isTechMode=true`
      );
      this.loading = false;
      this.loadingConversations = false;
      this.showConversationBtn = false;
      this.loadAllConversationsBtn = true;
      this.conversationList = conversations.map((c) => ({
        ...c,
        expanded: false,
        load: false,
      }));
    },

    async expandConversation(i) {
      if (this.conversationList[i].expanded) {
        this.conversationList[i].expanded = false;
        this.$set(this.conversationList, i, this.conversationList[i]);
        return;
      }
      this.conversationList[i].load = true;

      if (this.conversationList[i].type == "NOTES") {
        try {
          const response = await this.$http.get(
            `api/manageengine/GetNote?manageengineID=${
              this.conversationList[i].manageengineRequestID
            }&noteID=${this.conversationList[i].conversationID}`
          );
          this.conversationList[i].load = false;
          this.$set(this.conversationList, i, response);
        } catch {}
      } else {
        try {
          const response = await this.$http.get(
            `api/manageengine/GetConversation?manageengineID=${
              this.conversationList[i].manageengineRequestID
            }&conversationID=${this.conversationList[i].conversationID}`
          );
          this.conversationList[i].load = false;
          this.$set(this.conversationList, i, response);
        } catch {}
      }
      this.conversationList[i].expanded = true;
    },

    async expandAllConversations() {
      this.conversationList.map((c) => (c.load = true));
      this.loadAllConversationsBtn = false;
      for (var i = 0; i < this.conversationList.length; i++) {
        if (this.conversationList[i].type == "NOTES") {
          try {
            const response = await this.$http.get(
              `api/manageengine/GetNote?manageengineID=${
                this.conversationList[i].manageengineRequestID
              }&noteID=${this.conversationList[i].conversationID}`
            );
            this.conversationList[i].load = false;
            this.$set(this.conversationList, i, response);
            this.conversationList[i].expanded = true;
          } catch {}
        } else {
          try {
            const response = await this.$http.get(
              `api/manageengine/GetConversation?manageengineID=${
                this.conversationList[i].manageengineRequestID
              }&conversationID=${this.conversationList[i].conversationID}`
            );
            this.conversationList[i].load = false;
            this.$set(this.conversationList, i, response);
            this.conversationList[i].expanded = true;
          } catch {}
        }
      }
    },

    getConversationAttachments(attachments) {
      return JSON.parse(attachments);
    },
    getConversationAttachmentCount(attachments) {
      return (
        JSON.parse(attachments).length +
        " " +
        pluralize("Attachment", JSON.parse(attachments).length)
      );
    },
    getSendCTo(l) {
      return JSON.parse(l).join(", ");
    },

    async addNote() {
      try {
        this.processing = true;
        const desc = `${this.addNoteDescription.trim()}`;
        const description = desc
          .replace(/  /g, "&nbsp;")
          .replace(/\n/g, "<br>");

        const info = `<b>From: </b> ${
          this.$store.state.authentication.user
        } <hr /><br>`;

        await this.$http.post(
          `api/Manageengine/AddNote?data=${encodeURIComponent(
            info + description
          )}&manageEngineID=${this.request.manageengineID}&displayID=${
            this.request.displayID
          }`
        );

        this.$notify({
          text: "Note added successfully",
          group: "notification",
          type: "success",
        });
        this.addNoteDialog = false;
        await this.loadRequest();
        await this.getConversations();
        await this.expandConversation(this.conversationList.length - 1);
        this.processing = false;
      } catch (err) {
        console.error("Error adding note:", err);
        this.$notify({
          text: "massege not send",
          group: "notification",
          type: "error",
        });
      } finally {
        this.processing = false;
        this.addNoteDialog = false;
        this.addNoteDescription = "";
      }
    },

    async onStatusChange() {
      this.showStatusDropdown = false;
      if (this.selectedStatus == "Closed") {
        this.closeTicketDialog = true;
        return;
      }
      try {
        // this.reopenProcessing = true;
        await this.$http.put(`api/manageengine/EditTicket`, {
          statusName: this.selectedStatus,
          manageengineID: this.request.manageengineID,
          displayID: this.request.displayID,
        });
        await this.loadRequest();
        this.$notify({
          group: "notification",
          text: "Ticked Updated",
          type: "success",
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.reopenProcessing = false;
      }
    },
    async updated() {
      await this.loadRequest(), (this.activeTab = 0);
    },
    async reloadData() {
      await this.load();
      this.activeTab = 0;
    },

    defaultReplyTemplate() {
      let html = `<b>From: </b> ${this.$store.state.authentication.user
        .split("@")[0]
        .toUpperCase()}<hr />`;
      html += `Dear ${
        this.request.requesterName
      }, <hr style="border-top: 1px solid #eee; margin: 5px 0;">`;
      html += `<b>Our Reply:</b><br><br><br><br><br><br><br><hr/>`;

      html += `Technician: ${
        this.getTechnician() == "This ticket has not yet been assigned" ||
        this.getTechnician() == ""
          ? ""
          : this.getTechnician()
      }<br>`;
      html += `Category: ${
        this.request.categoryName == "" ? "" : this.request.categoryName
      }<br>`;
      //html += `Description: ${this.request.description},<br>`;
      html += `<br>Regards,<br>Our HelpDesk`;
      return html;
    },
    openReplyDialog() {
      if (this.request.requesterEmailID == null) {
        this.$notify({
          text: "User email is not available to reply to the ticket",
          group: "notification",
          type: "error",
        });
        return;
      }
      this.$refs.reply.innerHTML = this.replyTemplate = this.replyDescription = this.defaultReplyTemplate();
      this.replyDialog = true;
    },

    async technicianReply() {
      try {
        this.processing = true;
        const description = this.replyDescription.trim();

        await this.$http.post(`api/Manageengine/Reply`, {
          DisplayID: this.request.displayID,
          ManageengineID: this.request.manageengineID,
          Subject: `Re: [Request ID :##${this.request.displayID}##] : ${
            this.request.subject
          }`,
          Description: description,
          IsFromRequester: false, // false means the reply is from the technician
          technicianName: this.request.technicianName,
          RequesterEmailID: this.request.requesterEmailID,
        });
        this.$notify({
          text: "Reply sent successfully",
          group: "notification",
          type: "success",
        });
        await this.loadRequest();
        await this.getConversations();
        await this.expandConversation(this.conversationList.length - 1);
      } catch (error) {
        console.error("Error replying to ticket:", error);
        this.$notify({
          text: "Error replying to ticket",
          group: "notification",
          type: "error",
        });
      } finally {
        this.processing = false;
        this.replyDialog = false;
        this.replyDescription = "";
        this.replyTemplate = "";
      }
    },
    updateReplyDescription(e) {
      this.replyDescription = e.target.innerHTML;
    },
  },
};
</script>
<style>
.v-expansion-panel__header {
  height: 63px;
}

.spacail-needs-link {
  color: rgb(76, 175, 80);
  display: inline-block;
  word-wrap: break-word;
  width: 100%;
}

.tip-grid.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
}

.tip-grid .v-card__text {
  padding-top: 4px !important;
}

.tip-grid .flex {
  padding: 0px !important;
  padding-top: 24px !important;
}

.tip-grid .v-card {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
    0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}

.card-header {
  padding: 5px 0;
  font-weight: bold;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.ticket-card {
  word-wrap: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.button-attachment {
  max-width: 100%;
  display: block;
  margin-top: 8px;
  text-overflow: ellipsis;
}

.ticket-card audio {
  max-width: 100%;
  display: block;
  margin-top: 8px;
}

.attachments-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.status-text:hover {
  opacity: 0.7;
}

.ticket-tabs {
  margin-bottom: 0;
}

.tab-active {
  background-color: rgb(76, 175, 80) !important;
  color: white !important;
  font-weight: 600 !important;
}

.reply-editor {
  border: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 4px;
  padding: 12px;
  min-height: 300px;
  font-size: 14px;
  line-height: 1.6;
  outline: none;
  overflow-y: auto;
}

.reply-editor:focus {
  border-color: #4caf50;
  border-width: 2px;
}
</style>
